module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/leather@3x_e157e1.jpg";